module.exports = __webpack_public_path__ + "static/sql-29b524d0b6f487be03dea49ee2506120.png";